.container {
  height: 29px;
  border: none;
  width: 100%;
  font-family: inherit;
  padding-left: 2px;
}
